import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=16a058c4&scoped=true"
import script from "./Send.ts?vue&type=script&lang=ts&external"
export * from "./Send.ts?vue&type=script&lang=ts&external"
import style0 from "./Send.vue?vue&type=style&index=0&id=16a058c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a058c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a058c4')) {
      api.createRecord('16a058c4', component.options)
    } else {
      api.reload('16a058c4', component.options)
    }
    module.hot.accept("./Send.vue?vue&type=template&id=16a058c4&scoped=true", function () {
      api.rerender('16a058c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/CUR/pages/Send/Send.vue"
export default component.exports